(function () {
    "use strict";

	angular.module("cardFrontConsumer")
        .config(configHttpProvider);

    configHttpProvider.$inject = ["$httpProvider"];

    function configHttpProvider($httpProvider) {
        $httpProvider.interceptors.push("globalHttpInterceptor");
    }
}());